import { render, staticRenderFns } from "./ProformaList.vue?vue&type=template&id=422e81a0"
import script from "./ProformaList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProformaList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports